





































































































import { Component, Vue, Watch } from "vue-property-decorator";
import UserLessons from "@/components/lessons/userLessons.vue";
import { Team, LearnerTeam, License } from "@/types";
import teamChange from "@/components/teamChangeLearner.vue";
import Practice from "@/views/learner/learnerpractice.vue";
import Recordings from "@/views/learner/learnerrecordings.vue";
import LearnerAccount from "@/views/learner/learneraccount.vue";
import LearnerReviews from "@/views/learner/learnerReviews.vue";
import { Action, Getter } from "vuex-class";
import Parrot from "@/assets/images/parrot/ParrotMicSinging.svg?inline";
import consts from "@/consts";
import { getDomain } from "@/auth";

enum Tabs {
  library = "library",
  account = "account",
  recordings = "recordings",
  practice = "practice",
  review = "review",
}

@Component({
  components: {
    teamChange,
    UserLessons,
    Practice,
    Recordings,
    LearnerAccount,
    LearnerReviews,
    Parrot,
  },
})
export default class LearnerView extends Vue {
  private activeTab: string = "";
  private localDoneInitAssessment = false;
  private dataToCopy: any = [];
  private plans = [
    {
      heading: "License Tier 1",
      descriptions: [
        "Lifetime access to Orai",
        "Practice on the go with our iOS and Android Apps",
        "Unlimited Practise Mode minutes",
        "Multi-accent Support",
      ],
      isActive: false,
    },
    {
      heading: "License Tier 2",
      descriptions: [
        "Lifetime access to Orai",
        "Practice on the go with our iOS and Android Apps",
        "Unlimited Practise Mode minutes",
        "Multi-accent Support",
        "Lesson's library",
        "Up to 3 seats",
      ],
      isActive: false,
    },
    {
      heading: "License Tier 3",
      descriptions: [
        "Lifetime access to Orai",
        "Practice on the go with our iOS and Android Apps",
        "Unlimited Practise Mode minutes",
        "Multi-accent Support",
        "Lesson's library",
        "Up to 10 seats",
      ],
      isActive: false,
    },
    {
      heading: "License Tier 4",
      descriptions: [
        "Lifetime access to Orai",
        "Practice on the go with our iOS and Android Apps",
        "Unlimited Practise Mode minutes",
        "Multi-accent Support",
        "Lesson's library",
        "Up to 15 seats",
      ],
      isActive: false,
    },
  ];

  @Getter private doneInitAssessment?: any;
  @Getter private UID!: string;
  @Getter private userLicenseList!: License[];
  @Action private setCurrentLearnerTeam?: any;
  @Action private fetchUserLicenseList!: (uid: string) => any;
  @Getter private learnerTeamByID!: (id: number) => LearnerTeam;

  private created() {
    this.fetchUserLicenseList(this.UID);
  }

  private copytoclip(ind: number, l: any) {
    this.dataToCopy[
      ind
    ] = `I got you a lifetime license for Orai (an AI speech coach): https://orai.com 

Click this link to signup and get started: https://app.orai.com/signup?team_code=${l.LicenseKey} 

If that doesn't work, here's the code to access your lifetime subscription: ${l.LicenseKey}

And instructions on where to enter that code: https://appsumo.orai.com`;

    navigator.clipboard.writeText(this.dataToCopy[ind]);
  }

  private changeTeam(teamID: number) {
    let team = this.learnerTeamByID(teamID);
    this.setCurrentLearnerTeam(team);
    let domain = getDomain(window.location.href);
    (window as any).$cookies.set(
      consts.currentLearnerTeam,
      team,
      null,
      "/",
      domain
    );
  }

  private changePlan(plan: any) {
    if (!plan.isActive)
      window.open("https://appsumo.com/account/products/", "_blank");
  }

  private assignInitAssessment() {
    this.localDoneInitAssessment = this.doneInitAssessment;
  }

  @Watch("activeTab")
  private setURL() {
    if (this.activeTab === "") {
      console.log("asd");
      return;
    }
    this.assignInitAssessment();
    if (this.$route.query.tab === this.activeTab) {
      return;
    }
    this.$router.replace({
      name: "learnerhome",
      query: { tab: this.activeTab },
    });
  }

  @Watch("userLicenseList")
  private updateLiscenseListWithActiveLicense() {
    if (this.userLicenseList.length === 0) {
      this.plans[0].isActive = true;
    } else if (this.userLicenseList.length === 3) {
      this.plans[1].isActive = true;
    } else if (this.userLicenseList.length === 10) {
      this.plans[2].isActive = true;
    } else if (this.userLicenseList.length === 15) {
      this.plans[3].isActive = true;
    }
  }
}
